import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useFamilyAllowanceChartsDataContext } from './hooks/useFamilyAllowanceChartsDataContext';

export const FamiliesPerYear = () => {
    const { chartData } = useFamilyAllowanceChartsDataContext();

    const rawData = chartData?.families?.annual || [];

    const series = [
        {
            name: 'Famílias Beneficiárias',
            data: rawData.map(item => Number(item.value))
        }
    ];

    return (
        <SimpleBars
            title="Famílias Beneficiárias - Anual"
            horizontal={false}
            subtitles={rawData.map(item => getYearLabel(item.ano))}
            series={series}
        />
    );
};
